import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)

// Register the service worker
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('[PWA] Content cached correctly for offline use');
  },
  onUpdate: (registration) => {
    console.log('[PWA] New version available');
  }
});
